import { render } from "./BaseButton.vue?vue&type=template&id=67721966&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=67721966&scoped=true&lang=css"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67721966"]])

export default __exports__